import { useStyleGuidesOptions } from 'providers/StyleGuideProviders/useStyleGuidesOptions';
import { Option } from 'types/Option';

interface IUseOptionsStyleGuidesIn {
  attribute?: 'referenceId' | 'id';
}

interface IUseOptionsStyleGuidesOut {
  optionsStyleGuides: Option[];
}

export default function useOptionsStyleGuides({
  attribute = 'referenceId'
}: IUseOptionsStyleGuidesIn = {}): IUseOptionsStyleGuidesOut {
  const { data } = useStyleGuidesOptions();

  const optionsStyleGuides = [
    ...(data?.map((option) => ({
      label: option.name,
      value: String(option[attribute])
    })) ?? [])
  ];

  return { optionsStyleGuides };
}
